import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { checkUndeNullBlank } from "../../ObjectExist";

const Why = () => {
  const [viewModal, setViewModal] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const toggleView = (name) => {
    setViewModal(!viewModal);
    if (checkUndeNullBlank(name)) {
      setViewImage(name);
    }
  };

  return (
    <section
      class="space-top space-bottom-shape"
      background-image
      shape-mockup-wrap
      // style={{ backgroundImage: "url(./img/why_bg_1.jpg)" }}
    >
      <Modal
        isOpen={viewModal}
        toggle={viewModal}
        scrollable={true}
        className="addModal"
      >
        <ModalHeader toggle={toggleView} />
        <ModalBody className="d-flex justify-content-center">
          <img src={`./img/${viewImage}`} alt="iovivc" />
        </ModalBody>
      </Modal>

      <div class="container">
        <div class="row">
          {/* <div class="col-xl-6">
            <div class="group-img">
              <div class="img-wrap img-2">
                <img src="./img/meeting_3.jpg" alt="iovivc" />
                <span
                  class="icon-btn popup-image cursor-pointer"
                  onClick={() => toggleView("meeting_3.jpg")}
                >
                  +
                </span>
              </div>
              <div class="img-wrap img-1">
                <img src="./img/meeting_1.jpg" alt="iovivc" />
                <span
                  class="icon-btn popup-image cursor-pointer"
                  onClick={() => toggleView("meeting_1.jpg")}
                >
                  +
                </span>
              </div>

              <div class="img-wrap img-3">
                <img src="./img/meeting_4.jpg" alt="iovivc" />
                <span
                  class="icon-btn popup-image cursor-pointer"
                  onClick={() => toggleView("meeting_4.jpg")}
                >
                  +
                </span>
              </div>
              <div class="img-wrap img-4">
                <img src="./img/meeting_2.jpg" alt="iovivc" />
                <span
                  class="icon-btn popup-image cursor-pointer"
                  onClick={() => toggleView("meeting_2.jpg")}
                >
                  +
                </span>
              </div>
            </div>
          </div> */}
          <div class="col-xl-6 text-sm-start text-left">
            {/* <span class="sub-title2">
              <img
                class="title-shape"
                src="./img/title_shape.png"
                alt="title shape"
              />
            </span> */}
            <h4 class="sec-title-ndm mb-35">WHY TO ATTEND IVC? </h4>
            <p className="mb-35" style={{ fontSize: "14px" }}>
              1.&nbsp;Clarity on the importance and purpose of valuation along
              with relevant legal provisions
              <br />
              2.&nbsp;Sessions by renowned speakers with vast experience and
              subject expertise
              <br />
              3.&nbsp;Opportunity for face-to-face interaction and meaningful
              knowledge exchange
              <br />
              4.&nbsp;Enriching experience through practical insights and
              real-world discussion
              <br />
              5.&nbsp;Continuous skill enhancement through exposure to the
              latest practices
              <br />
              6.&nbsp;Updates on regulatory changes, valuation standards, and
              industry trends
              <br />
              7.&nbsp;Broader perspective on valuation across sectors and asset
              classes
              <br />
              8.&nbsp;Strong networking opportunities with fellow professionals
              and institutions
              <br />
              9.&nbsp;CEP credit hours for Registered Valuers as per IBBI
              guidelines
              <br />
              10.&nbsp;Active Valuer credits for IOV Members for professional
              growth and recognition
            </p>

            {/* <Link to="https://www.iovivc.com/register " className="btn-grad">
              Register
            </Link> */}
          </div>
          {/* <div class="map-slide-wrap col-xl-6">
            <div
              class="vs-carousel slick-initialized slick-slider"
              data-asnavfor="#locationSlide"
              id="mapSlide"
              data-fade="true"
              data-slide-show="1"
              data-md-slide-show="1"
            >
              <div class="slick-list draggable">
                <div class="slick-track" style={{ opacity: 1, width: "" }}>
                  <iframe
                    width="700"
                    height=""
                    src="https://www.youtube.com/embed/iJ3tq6TrIVY?si=h8QS6wiWCA9fxXBd-z&autoplay=1&controls=0&loop=1&mute=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div> */}
          <div class="col-xl-6 col-lg-6 justify-content-center">
            <div class="map-slide-wrap col-xl-12">
              <div
                class="vs-carousel slick-initialized slick-slider"
                data-asnavfor="#locationSlide"
                id="mapSlide"
                data-fade="true"
                data-slide-show="1"
                data-md-slide-show="1"
              >
                <div class="slick-list draggable">
                  <div class="slick-track" style={{ opacity: 1, width: "" }}>
                    <iframe
                      width="700"
                      height=""
                      src="https://www.youtube.com/embed/iJ3tq6TrIVY?si=h8QS6wiWCA9fxXBd-z&autoplay=1&controls=0&loop=1&mute=1"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        class="shape-mockup jump d-none d-xl-block"
        style={{ top: "34%", left: "0%" }}
      >
        <img src="./img/line-8.png" alt="iovivc" />
      </div>
      <div
        class="shape-mockup movingX d-none d-xxl-block"
        style={{ right: "24%", bottom: "20%" }}
      >
        <img src="./img/line-9.png" alt="iovivc" />
      </div> */}
    </section>
  );
};
export default Why;
